import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import { Loading, Perm } from "@/components/common";
import Login from "@/pages/Login";
import Dashboard from "@/pages/tenant/Dashboard";
import Customers from "@/pages/tenant/Customers";
import Recap from "@/pages/tenant/Recap";
import Debts from "@/pages/tenant/Debts";
import Reconciliation from "@/pages/tenant/Reconciliation";
import Estimate from "@/pages/tenant/Estimate";
import Invoices from "@/pages/tenant/Invoices";
import PrintNota from "@/pages/tenant/PrintNota";
import Prices from "@/pages/tenant/Prices";
import HistoryPage from "@/pages/tenant/History";
import CompanySettings from "@/pages/tenant/CompanySettings";
import TenantUsers from "@/pages/tenant/Users";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminTenants from "@/pages/admin/AdminTenants";
import AdminUsers from "@/pages/admin/AdminUsers";
import RevisionQueue from "@/pages/admin/RevisionQueue";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminSettings from "@/pages/admin/AdminSettings";
import CompanyPicker from "@/pages/CompanyPicker";
import { homePath } from "@/components/nav";

function Guard({ mode }) {
  const { session, can } = useAuth();
  if (session === null) return <Loading />;
  if (!session) return <Navigate to="/login" replace />;
  if (mode === "admin" && !can("platform:view")) return <Navigate to={homePath(session)} replace />;
  if (mode === "tenant" && !session.tenant) return <Navigate to={homePath(session)} replace />;
  return <AppLayout mode={mode}><Outlet /></AppLayout>;
}

function HomeRoute() {
  const { session, can } = useAuth();
  return can("dashboard:read") ? <Dashboard /> : <Navigate to={homePath(session)} replace />;
}

const P = (perm, el) => <Perm perm={perm}>{el}</Perm>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/pilih-perusahaan" element={<CompanyPicker />} />
            <Route element={<Guard mode="admin" />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/perusahaan" element={P("platform:manage", <AdminTenants />)} />
              <Route path="/admin/pengguna" element={P("platform:manage", <AdminUsers />)} />
              <Route path="/admin/revisi" element={P("revision:approve", <RevisionQueue />)} />
              <Route path="/admin/audit" element={<AdminAudit />} />
              <Route path="/admin/pengaturan" element={P("platform:manage", <AdminSettings />)} />
            </Route>
            <Route element={<Guard mode="tenant" />}>
              <Route path="/" element={<HomeRoute />} />
              <Route path="/pelanggan" element={P("customer:read", <Customers />)} />
              <Route path="/rekap" element={P("recap:read", <Recap />)} />
              <Route path="/hutang" element={P("debt:read", <Debts />)} />
              <Route path="/rekonsiliasi" element={P("topup:read", <Reconciliation />)} />
              <Route path="/estimasi" element={P("estimate:read", <Estimate />)} />
              <Route path="/invoice" element={P("invoice:read", <Invoices />)} />
              <Route path="/cetak" element={P("print:run", <PrintNota />)} />
              <Route path="/harga" element={P("price:read", <Prices />)} />
              <Route path="/riwayat" element={P("history:read", <HistoryPage />)} />
              <Route path="/pengaturan" element={P("company:read", <CompanySettings />)} />
              <Route path="/pengguna" element={P("user:manage", <TenantUsers />)} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
